module.exports = __webpack_public_path__ + "static/4-a77a4807b4410995ebaf18a28230a64d.jpg";